import { createApp } from "vue";
import * as Sentry from '@sentry/vue';
import App from "./App.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faArrowLeft,
  faCopy,
  faPlusSquare,
  faQuestionCircle,
  faInfoCircle,
  faLightbulb,
  faFolderOpen,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faAngleDown,
  faArrowToTop,
  faFolder,
  faArrowRight,
  faArrowUp,
  faSearch,
  faTimes,
  faCheck,
  faInfo,
} from '@fortawesome/pro-solid-svg-icons';
import "./index.css";
import router from "./router";

library.add(
  // Regular
  faCopy,
  faPlusSquare,
  faArrowLeft,
  faQuestionCircle,
  faInfoCircle,
  faLightbulb,
  faFolderOpen,
  faUsers,
  // Solid
  faAngleDown,
  faFolder,
  faArrowToTop,
  faArrowRight,
  faArrowUp,
  faSearch,
  faTimes,
  faCheck,
  faInfo,
);

// workaround for vue router bug https://github.com/OfficeDev/office-js/pull/2808
function boot(): Promise<void> {
  const replaceState = window.history.replaceState;
  const pushState = window.history.pushState;

  return new Promise(async resolve => {
    const script = document.createElement('script')
    script.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js'
    script.onload = () => {
      Office.onReady(() => {
        window.history.replaceState = replaceState;
        window.history.pushState = pushState;

        resolve()
      })
    }

    document.body.appendChild(script)
  })
}

boot().then(() => {
  window.Office.onReady(() => {
    const app = createApp(App);

    Sentry.init({
      app,
      dsn: "https://342ad9a716ac34dad02f4ac69e707f1e@o4512203041275904.ingest.de.sentry.io/4512204746063952",
      integrations: [
        Sentry.browserTracingIntegration({
          router,
        }),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });

    app.component("fa", FontAwesomeIcon);
    app.use(router);
    app.mount("#app");
  })
});
